module.exports = __webpack_public_path__ + "img/icon2@2x.bed2a291.png";